<template>
  <div class="transportation-behavior-page nx-page nx-report-page">
    <SearchCard v-model="queryForm" @handleQuery="handleQuery"></SearchCard>
    <div class="content-wrap" v-loading="loading">
      <el-card class="header-card">
        <div class="header-info">
          <div class="customer-info">
            <div class="customer-name">{{ form.custName || '--' }}</div>
            <div class="customer-code">客户ID：{{ form.custNo || '--' }}</div>
          </div>
          <div class="tags">
            <el-tag size="small" type="info">客户价值</el-tag>
            <el-tag size="small" type="primary">{{ valueLevelText }}</el-tag>
          </div>
        </div>
        <el-row :gutter="12" class="metric-row">
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">信用额度</div>
              <div class="amount">¥{{ form.creditMoney || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">预付款余额</div>
              <div class="amount">¥{{ form.cashPreMoney || 0 }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">月发运频次</div>
              <div class="amount">{{ form.planMonth || 0 }} 次/月</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">常用煤种</div>
              <div class="amount">{{ form.cargoCount || 0 }} 种</div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="12" class="metric-row">
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">当前库存量</div>
              <div class="amount">{{ form.currentStockAmount || 0 }} 吨</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">铁运入库量</div>
              <div class="amount">{{ form.trainInWeight || 0 }} 吨</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">汽运入库量</div>
              <div class="amount">{{ form.carInWeight || 0 }} 吨</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="info-item">
              <div class="info-label">汽运出库量</div>
              <div class="amount">{{ form.totalOutWeight || 0 }} 吨</div>
            </div>
          </el-col>
        </el-row>
        <div class="progress">
          <div class="progress-header">
            <span>月度计划完成进度</span>
            <span>计划 {{ form.planTotalWeight || 0 }} 吨 / 已完成 {{ form.planExecuteWeight || 0 }} 吨</span>
          </div>
          <el-progress :percentage="form.executeProgress || 0" :format="formatProgress"></el-progress>
        </div>
      </el-card>
      <ChartsCard ref="chartsCard" :query="queryForm"></ChartsCard>
    </div>
  </div>
</template>

<script>
import ChartsCard from './components/charts-card.vue'
import SearchCard from './components/search-card.vue'

import { selectCustTransBehavior } from "./api";
export default {
  name: 'TransportationBehavior',
  components: {
    ChartsCard,
    SearchCard
  },
  data () {
    return {
      form: {},
      queryForm: { custNo: this.$route.query.custNo || '' },
      loading: false
    }
  },
  created () {
    this.init()
  },
  computed: {
    valueLevelText () {
      const textMap = {
        0: '低',
        1: '中',
        2: '高'
      }
      return textMap[this.form.valueLevel] || '--'
    }
  },
  methods: {
    init () {
      selectCustTransBehavior(this.queryForm).then(({ data: { data } }) => {
        this.form = data
      }).finally(() => {
        setTimeout(() => {
          this.loading = false
        }, 500);
      })
    },
    handleQuery () {
      this.loading = true
      this.init()
      this.$nextTick(() => {
        if (this.$refs.chartsCard) this.$refs.chartsCard.init()
      })
    },
    formatProgress (percentage) {
      return `${percentage}%`
    },
  }
}
</script>

<style scoped lang="scss">
.transportation-behavior-page {
  padding: 0;
  background: transparent;
  --behavior-gap: 12px;
}

.content-wrap {
  min-height: 0;
}

.header-card {
  margin-bottom: var(--behavior-gap);
  border: 1px solid #ebeef5;
  border-radius: 4px;

  ::v-deep .el-card__body {
    padding: 14px 16px 16px;
  }
}

.header-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.customer-info {
  min-width: 0;

  .customer-name {
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
    color: #1f2937;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .customer-code {
    margin-top: 4px;
    font-size: 12px;
    line-height: 18px;
    color: #6b7280;
  }
}

.tags {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.metric-row + .metric-row {
  margin-top: var(--behavior-gap);
}

.info-item {
  min-height: 76px;
  padding: 12px 14px;
  background-color: #f8fbff;
  border: 1px solid #edf2f7;
  border-radius: 4px;
  box-sizing: border-box;

  .info-label {
    margin-bottom: 8px;
    font-size: 12px;
    line-height: 18px;
    color: #6b7280;
  }

  .amount {
    display: inline-block;
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
    color: #111827;
  }
}

.progress {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #ebeef5;

  .progress-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 8px;
    font-size: 13px;
    line-height: 20px;
    color: #1f2937;

    span:last-child {
      color: #6b7280;
      font-size: 12px;
    }
  }
}

@media (max-width: 1200px) {
  .metric-row {
    .el-col {
      width: 50%;
    }
  }
}
</style>
